module.exports = __webpack_public_path__ + "ath_game_web/img/8.5.abfb2f4a.png";